import { render, staticRenderFns } from "./PlanControl.vue?vue&type=template&id=23560a3d&"
import script from "./PlanControl.vue?vue&type=script&lang=js&"
export * from "./PlanControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports